import React, { FC } from 'react'

import { IconSohoProps } from './IconSoho.types'
import * as Styled from './styles/IconSoho.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSoho: FC<IconSohoProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSohoProps['size'],
  isResponsive = false,
}: IconSohoProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M11 19v5.05c0 2.84 2.75 3.044 2.75 3.044H14M37 19v5.05c0 2.84-2.75 3.044-2.75 3.044H34'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 29v12.23' stroke='#0D0D0D' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M21 5h10v16c0 2.21-1.79 4-4 4h-6c-2.21 0-4-1.79-4-4V9c0-2.21 1.79-4 4-4Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='m15.086 41.816 2.23-5.57h13.368l2.23 5.57' stroke='#0D0D0D' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M15 25h18c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H15c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M16 42c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1Z' stroke='#E60000' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M15.625 42a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M15.25 42c0 .137-.113.25-.25.25a.252.252 0 0 1-.25-.25c0-.137.113-.25.25-.25s.25.113.25.25ZM25 42c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.625 42a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.25 42c0 .137-.113.25-.25.25a.252.252 0 0 1-.25-.25c0-.137.113-.25.25-.25s.25.113.25.25Zm9.625 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M33.5 42a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625s.625.281.625.625Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M33.125 42c0 .137-.113.25-.25.25a.252.252 0 0 1-.25-.25c0-.137.113-.25.25-.25s.25.113.25.25Z'
          stroke='#E60000'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSoho
